export { default } from './statistics';
